<template>
  <div class="main">
    <template v-if="error.statusCode === 404">
      <not-found />
    </template>
    <template v-else>
      <errorPage :error-code="error.statusCode" :message="error.message" />
    </template>
  </div>
</template>

<script>
export default {
  name: "Error",
  components: {
    notFound: () => import("../pages/not-found"),
    errorPage: () => import("../pages/error"),
  },
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style scoped>
.main {
  display: flex;
}
</style>
